import React from 'react';
import PrintAgreementPageComponent from './print-agreement.component';

const PrintAgreementPageContainer = (props) => {
    return <PrintAgreementPageComponent {...props} />;
};

export default PrintAgreementPageContainer;
